/** Assignee pool rules accepted by the server (`assigneePoolRef`). */
export const ASSIGNEE_POOL_TYPE = Object.freeze({
  SPECIFIC: 'specific',
  /** No selection — inherit (template actor / trigger → template pool). */
  TRIGGER_ASSIGNEE: 'trigger_assignee',
  /** Explicitly unassigned — no person is set. */
  NONE: 'none',
  ROUND_ROBIN: 'round_robin',
  WEIGHTED_ROUND_ROBIN: 'weighted_round_robin',
})

export const ASSIGNEE_POOL_TYPES = Object.freeze([
  ASSIGNEE_POOL_TYPE.TRIGGER_ASSIGNEE,
  ASSIGNEE_POOL_TYPE.NONE,
  ASSIGNEE_POOL_TYPE.SPECIFIC,
  ASSIGNEE_POOL_TYPE.ROUND_ROBIN,
  ASSIGNEE_POOL_TYPE.WEIGHTED_ROUND_ROBIN,
])

/** Pool types that intentionally carry no `values`. */
export const ASSIGNEE_POOL_TYPES_WITHOUT_VALUES = Object.freeze([
  ASSIGNEE_POOL_TYPE.TRIGGER_ASSIGNEE,
  ASSIGNEE_POOL_TYPE.NONE,
])

export const DEFAULT_ASSIGNEE_POOL_TYPE = ASSIGNEE_POOL_TYPE.TRIGGER_ASSIGNEE

/** i18n keys for pool rule labels — resolve with `t()` at use time. */
export const ASSIGNEE_POOL_TYPE_I18N_KEY = Object.freeze({
  [ASSIGNEE_POOL_TYPE.TRIGGER_ASSIGNEE]: 'tickets.settings.fields.noAssigneeSelection',
  [ASSIGNEE_POOL_TYPE.NONE]: 'tickets.settings.fields.noAssignee',
  [ASSIGNEE_POOL_TYPE.SPECIFIC]: 'tickets.settings.templates.assigneeRuleSpecific',
  [ASSIGNEE_POOL_TYPE.ROUND_ROBIN]: 'tickets.settings.templates.assigneeRuleRoundRobin',
  [ASSIGNEE_POOL_TYPE.WEIGHTED_ROUND_ROBIN]: 'tickets.settings.templates.assigneeRuleWeightedRoundRobin',
})
